import React from 'react';
import { inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import FileUploader from '../../../../lib/containers/file-upload/FileUploader';
import { uploader } from '../../../../services/uploader';
import messages from '../messages';
import { file } from '@dc-framework/js-utils';
import File from '../../../../models/File';
import CardItemFile from '../../../../models/CardItemFile';
import { defaultFormButtons } from '../../../../lib/helpers/copy';
import { MODAL_TYPES } from '../../../../models/ModalData';
// import { Button } from '../../../../lib/components';
import { CardItemFileType } from '../../../../constants';

const { MIME_TYPES_PRESETS, getMimeTypesByPreset } = file;

export const ContentBlockFile = injectIntl(
  inject('rootStore')(
    ({
      intl,
      contentBlock,
      onChange,
      onBrowseFileManager,
      rootStore: { uiState },
      disabled
    }) => {
      return (
        <>
          {/*<Button
            ghost
            type="button"
            onClick={() => {
              contentBlock.files.push(
                new CardItemFile({
                  type: CardItemFileType.LINK,
                  url:
                    'https://iculture.textopus.nl/wp-content/uploads/2014/06/The-Test-Fun-for-Friends-iPhone-iPad.png',
                  name: 'My link'
                })
              );
              onChange && onChange(contentBlock);
            }}
          >
            Add dummy link
          </Button>*/}
          <FileUploader
            disabled={disabled}
            id={contentBlock.id}
            placeholder={
              contentBlock.label
                ? contentBlock.label
                : intl.formatMessage(messages.articleEditorFilesPlaceholder)
            }
            label={
              contentBlock.label
                ? contentBlock.label
                : intl.formatMessage(messages.articleEditorFilesLabel)
            }
            noLabelDropzone
            value={contentBlock.files.map(v => new File(v.file || v))}
            multiple={true}
            labelFileManager={intl.formatMessage(
              messages.articleEditorFilesManagerLabel
            )}
            onBrowseFileManager={() => {
              onBrowseFileManager && onBrowseFileManager(contentBlock);
            }}
            uploader={uploader}
            accept={getMimeTypesByPreset(MIME_TYPES_PRESETS.ALL_DOCS)}
            onChange={e => {
              const files = e.map(file => {
                const currentCardItemFile = contentBlock.files.find(
                  cardItemFile => {
                    return (
                      (cardItemFile.file && cardItemFile.file.id === file.id) ||
                      (cardItemFile.type === CardItemFileType.LINK &&
                        file.url === cardItemFile.url)
                    );
                  }
                );
                if (currentCardItemFile) return currentCardItemFile;
                return new CardItemFile({
                  file,
                  fileId: file.id,
                  type: file.type
                });
              });
              contentBlock.files = files;
              onChange && onChange(contentBlock);
            }}
            confirmModal={okHandler => {
              uiState.showModal({
                title: intl.formatMessage(messages.modalConfirmRemoveFileTitle),
                message: intl.formatMessage(
                  messages.modalConfirmRemoveFileMessage
                ),
                type: MODAL_TYPES.ALERT,
                okLabel: defaultFormButtons.REMOVE,
                okHandler
              });
            }}
          />
        </>
      );
    }
  )
);
